import { ReactNode } from 'react';

import Form from '@atlaskit/form';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { useAccountCreationContext } from '../../hooks/account-creation-context';
import { Error as DefaultError } from '../error/error';
import { Input as DefaultInput } from '../input/input';
import { Login as DefaultLogin } from '../login/login';
import { Separator as DefaultSeparator } from '../separator/separator';
import { Social as DefaultSocial } from '../social/social';
import { Submit as DefaultSubmit } from '../submit/submit';
import { TermsAndConditions as DefaultTermsAndConditions } from '../terms-and-conditions/terms-and-conditions';

export const Content = ({
	Submit = <DefaultSubmit />,
	Input = <DefaultInput />,
	Social = <DefaultSocial />,
	Separator = <DefaultSeparator />,
	Error = <DefaultError />,
	Login = <DefaultLogin />,
	TermsAndConditions,
}: {
	Submit?: ReactNode;
	Input?: ReactNode;
	Separator?: ReactNode;
	Social?: ReactNode;
	Error?: ReactNode;
	Login?: ReactNode;
	TermsAndConditions?: ReactNode;
}) => {
	const { onSubmit } = useAccountCreationContext();

	if (
		TermsAndConditions === undefined &&
		checkFeatureFlagGate(featureFlags.accountCreationTermsAndConditions)
	) {
		TermsAndConditions = <DefaultTermsAndConditions />;
	}

	return (
		<>
			<Form onSubmit={onSubmit} isDisabled={false}>
				{({ formProps }) => (
					<form {...formProps} autoComplete="off" data-testid="account-creation">
						{Input}
						{TermsAndConditions}
						{Submit}
					</form>
				)}
			</Form>
			{Error}
			{Separator}
			{Social}
			{Login}
		</>
	);
};
